import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import moment from "moment";
import { useState } from "react";
import { searchByProp } from "utils/search";
import AddToPriceListsView from "./AddToPriceListsView";

const ProductListView = ({ loading, error, data, q }) => {
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors errors={[error]} />;

  const products = data.products.results
    .filter((i) => searchByProp(i, ["name", "number"], q))
    .sort(
      (a, b) =>
        // sort by latest createdAt
        new Date(b.createdAt) - new Date(a.createdAt),
    );

  function tryAddToPriceList(productIds) {
    modal.present({
      title: "Add Products to Price Lists",
      subtitle: "Add product to multiple price lists with specific prices.",
      children: (
        <AddToPriceListsView
          products={products.filter((p) => productIds.includes(p.id))}
        />
      ),
      fullscreen: true,
    });
  }

  if (products.length === 0)
    return <div className="p-6">No products found.</div>;

  return (
    <table className="whitespace-nowrap">
      <thead>
        <tr className="sticky top-0 backdrop-blur-xl dark:bg-opacity-90 z-10">
          <th colSpan={2} className="px-4 py-3">
            <div className="flex items-center space-x-4">
              {selectedProductIds.length > 0 ? (
                <div className="flex items-center space-x-4">
                  <span>
                    {selectedProductIds.length} product
                    {selectedProductIds.length > 1 ? "s" : ""} selected
                  </span>
                  <Button onClick={() => tryAddToPriceList(selectedProductIds)}>
                    Add to Price List(s)
                  </Button>
                  <Button danger onClick={() => setSelectedProductIds([])}>
                    Clear
                  </Button>
                </div>
              ) : (
                <span>Product({data.products.total})</span>
              )}
            </div>
          </th>
          <th className="text-right px-4">Created at</th>
        </tr>
      </thead>
      <tbody>
        {products.map((product) => (
          <tr
            key={product.id}
            className="border-y border-gray-50 dark:border-gray-700"
          >
            <td className="px-4">
              <input
                type="checkbox"
                checked={selectedProductIds.includes(product.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedProductIds([...selectedProductIds, product.id]);
                  } else {
                    setSelectedProductIds(
                      selectedProductIds.filter((id) => id !== product.id),
                    );
                  }
                }}
              />
            </td>
            <td className="w-full px-0">
              <div>
                <span className="font-semibold">
                  {product.number || " - "}
                  {product.version ? ` | v${product.version}` : ""}
                </span>
                <span className="opacity-50 text-xs pl-2">
                  #W:{product.id},#OD:{product.odooId}
                </span>
              </div>
              <div className=" opacity-70">{product.name}</div>
            </td>
            <td className="text-right px-4">
              {moment(product.createdAt).format("YYYY-MM-DD")}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProductListView;
